module.exports = __webpack_public_path__ + "img/icon_bus.e5b73c24.svg";